import React from 'react'

// Текущее время с обновлением раз в intervalMs: по нему гаснет то, у чего истёк срок
export const useNow = (intervalMs: number) => {
  const [now, setNow] = React.useState(() => Date.now())

  React.useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs)
    return () => window.clearInterval(timer)
  }, [intervalMs])

  return now
}
